import shajs from 'sha.js';

const hashString = data => (data ? shajs('sha256').update(data).digest('hex') : '');

export default hashString;
